import TopAppBar from '../global/TopBar';
import SideBar from '../global/SideBar';
import { Box } from '@mui/material';

const AdminFrame = ({children}) => {
  return (
    <Box className="d-flex" sx={{ height: '100vh' }}>
      <SideBar />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1,
        minWidth: 0 // Prevents flex items from overflowing
      }}>
        <TopAppBar />
        <Box 
          sx={{ 
            flex: 1,
            overflow: 'auto',
            p: 2
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminFrame;